var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.9347C5.89765 18.9347 2.16669 15.2037 2.16669 10.6013C2.16669 5.99895 5.89765 2.26799 10.5 2.26799C15.1024 2.26799 18.8334 5.99895 18.8334 10.6013C18.8334 15.2037 15.1024 18.9347 10.5 18.9347ZM10.5 17.268C14.1819 17.268 17.1667 14.2832 17.1667 10.6013C17.1667 6.91942 14.1819 3.93466 10.5 3.93466C6.81812 3.93466 3.83335 6.91942 3.83335 10.6013C3.83335 14.2832 6.81812 17.268 10.5 17.268ZM14.25 6.85132L12.1667 12.268L6.75002 14.3513L8.83335 8.93466L14.25 6.85132ZM10.5 11.4347C10.9603 11.4347 11.3334 11.0616 11.3334 10.6013C11.3334 10.1411 10.9603 9.76799 10.5 9.76799C10.0398 9.76799 9.66669 10.1411 9.66669 10.6013C9.66669 11.0616 10.0398 11.4347 10.5 11.4347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.10fef69b9f5f0bd5940a8454c8cf4c7d.svg";
export { ForwardRef as ReactComponent };